import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Outlet, useParams } from "react-router";
import { useAuthService } from "../../adapters/auth/useAuthService.ts";
import { useAppName } from "../../adapters/insights-agent/state/hooks/useAppName.ts";
import { useConfig } from "../../adapters/insights-agent/state/hooks/useConfig.ts";
import { useFeatureFlagValue } from "../../config/FeatureFlagManager/hooks.ts";
import { Header } from "../../feature-components/Header/Header.tsx";
import styles from "./DeepResearchLayout.module.css";
import { ConnectedHistorySidebar } from "./connected-components/ConnectedHistorySidebar.tsx";
import { ConnectedReferencesSidebar } from "./connected-components/ConnectedReferencesSidebar.tsx";
import { ResearchId } from "../../adapters/insights-agent/state/AppState.ts";

export const DeepResearchLayout = () => {
  const authService = useAuthService();
  const { environment } = useConfig();
  const enableGlobalNav = useFeatureFlagValue("enableGlobalNav");
  const { id } = useParams();

  return (
    <div className={styles.DeepResearchLayout}>
      <Header
        isAuthenticated
        enableGlobalNav={enableGlobalNav}
        onLogoutClick={authService.logout}
        env={environment}
        appTitle={useAppName()}
      />
      <div className={styles.WorkflowGrid}>
        <PanelGroup direction="horizontal" autoSaveId="deep-research-layout">
          <Panel minSize={10} defaultSize={13}>
            <ConnectedHistorySidebar />
          </Panel>
          <PanelResizeHandle className={styles.ResizeHandle} />
          <Panel minSize={50} defaultSize={87}>
            <Outlet />
          </Panel>
          {id && id !== "new" && (
            <>
              <PanelResizeHandle className={styles.ResizeHandle} />
              <Panel minSize={30} defaultSize={37}>
                <ConnectedReferencesSidebar researchId={id as ResearchId} />
              </Panel>
            </>
          )}
        </PanelGroup>
      </div>
    </div>
  );
};
